/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const adminRoutes = {
  ADMIN_HOME: '/',
  ADMIN_USERS: 'users',
  ADMIN_ENQUIRIES: 'enquiries',
  ADMIN_DATASETS: 'datasets',
  ADMIN_DATASETS_CATEGORIES: 'datasets-categories',
  ADMIN_SYSTEM_CONFIG: 'system-config',
  ADMIN_EMAIL_CONFIG: 'email-config',
  ADMIN_IMPRINT_CONFIG: 'imprint-config',
  ADMIN_SUPPORT_CONFIG: 'support-config',
  ADMIN_SEND_EMAIL: 'send-email',
  ADMIN_ORGANIZATIONS: 'organizations',
  ADMIN_CLUSTERS_ORPHANS: 'clusters/orphans',
  ADMIN_MANAGE_PLANS_STORAGE: 'manage-plans/storage',
  ADMIN_MANAGE_PLANS_COMPUTE: 'manage-plans/compute',
  ADMIN_MANAGE_PLANS_SUPPORT: 'manage-plans/support',
};
